import { takeLatest, call, put } from 'redux-saga/effects';
import axios from 'axios';
import { func } from 'prop-types';
import URLS from '../constants/urls';
import { callApi, getWithoutBaseURL } from '../utils/api';
import * as SnackbarAction from '../actions/snackbarAction';
import * as KycAction from '../actions/kycAction';
import * as landingPageAction from '../actions/landingPageAction';
function* fullKyc(action) {
  try {
    const response = yield call(
      callApi,
      URLS.FULL_KYC,
      'POST',
      action.payload,
      true,
    );
    yield put(landingPageAction.getuserinfo());
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* minKyc(action) {
  try {
    const response = yield call(callApi, URLS.MIN_KYC, 'POST', action.payload);
    yield put(KycAction.setMinKycDetails(response.res_data));
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* getCityState(action) {
  try {
    const apiKey = '579b464db66ec23bdd000001db33706b81e8493e7f25caed02caf467';
    const resourcesId = '6176ee09-3d56-4a3b-8115-21841576b2f6';
    const zip = action.pin;
    const url = `https://api.data.gov.in/resource/${resourcesId}?api-key=${apiKey}&format=json&filters[pincode]=${zip}`;

    const response = yield call(getWithoutBaseURL, url);
    const addressObj =
      (response &&
        response.records &&
        response.records.length &&
        response.records[0]) ||
      [];
    yield put(KycAction.setCityState(addressObj));
    yield put(
      SnackbarAction.openSnackbar({
        message: 'address fetched successfully',
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error,
        type: 'error',
      }),
    );
  }
}

function* saveAddress(action) {
  try {
    // let isFormData = action.method === 'POST'
    const response = yield call(
      callApi,
      URLS.KYCADDRESS,
      action.method,
      action.payload,
      false,
      false,
      false,
      true,
    );
    // yield put(KycAction.(response.res_data));
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* getVideoKyc(action) {
  try {
    const response = yield call(callApi, URLS.VIDEOKYC, 'POST', action.payload);
    const link = (response.res_data && response.res_data.redirect_url) || '';
    // yield put(KycAction.setVideoKycLink(link));
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: response.res_str,
    //     type: 'success',
    //   }),
    // );
    if (link) {
      window.open(link, '_blank');
    }
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* getKycDocType(action) {
  try {
    const response = yield call(callApi, URLS.DOCTYPE, 'GET', action.payload);
    yield put(KycAction.setKycDocType(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* KYCSaga() {
  yield takeLatest('FULL_KYC', fullKyc);
  yield takeLatest('MIN_KYC', minKyc);
  yield takeLatest('KYC_PIN', getCityState);
  yield takeLatest('SAVE_ADDRESS', saveAddress);
  yield takeLatest('VIDEO_KYC', getVideoKyc);
  yield takeLatest('GET_DOC_TYPE', getKycDocType);
}
